/**
 * FlowFrameworkJs和FlowFrameworkPHP采用同套解析模式
 */
export default class FlowFramework {
  graph_data={};
  all_graph_list=[];
  static business_list=[
    {name:'无', value:0, node_type:''},
    {name:'开始', value:1, node_type:'start'},
    {name:'条件', value:2, node_type:'exclusiveGateway'},
    {name:'审批', value:3, node_type:'user'},
    {name:'会签', value:4, node_type:'user'},
    {name:'委托', value:5, node_type:'user'},
    {name:'抄送', value:6, node_type:'user'},
    {name:'服务', value:7, node_type:'setting'},
    {name:'分流', value:8, node_type:'distributary'},
    {name:'合流', value:9, node_type:'confluence'},
    {name:'结束', value:10, node_type:'end'},
    {name:'流线', value:11, node_type:'polyline'},
  ];
  constructor(data) {
    this.graph_data=data;
    this.all_graph_list=[
      ...this.graph_data['nodes'],
      ...this.graph_data['edges']
    ];
  }

  getAllGraphList(){
    return this.all_graph_list
  }

  /**
   * 获取序列节点（默认为开始-不包含线）
   * @param start_id
   * @returns {*[]}
   */
  getNodeSequence(start_id=''){
    if(!start_id){
      start_id=this.getStart().id;
    }
    let list=[];
    let node_ids=[start_id];
    this.addLine(list,start_id,node_ids);
    return list;
  }

  /**
   * 获取序列节点（默认为开始-全部）
   * @param start_id
   * @returns {*[]}
   */
  getSequence(start_id=''){
    if(!start_id){
      start_id=this.getStart().id;
    }
    let list=[];
    this.addAllLine(list,start_id,[start_id]);
    return list;
  }

  /**
   * 下一个节点（不包含线点）
   * @param start_id
   * @returns {null|*}
   */
  nextNode(start_id=''){
    let ids=this.getNodeSequence(start_id);
    if(ids[1]){
      return this.findNode('id',ids[1]);
    }
    return null;
  }

  /**
   * 下一个节点（全部）
   * @param start_id
   * @returns {null|*}
   */
  nextAllNode(start_id=''){
    let ids=this.getSequence(start_id);
    if(ids[1]){
      return this.find('id',ids[1]);
    }
    return null;
  }

  /**
   * 按序列化全部（只有节点ID）
   * @returns {*[]}
   */
  getAllNodeSequence(){
    let start_id=this.getStart().id;
    let list=[];
    let node_ids=[start_id];
    this.addLine(list,start_id,node_ids);
    return list;
  }

  /**
   * 按序列化全部(包含线路ID)
   * @returns {*[]}
   */
  getAllSequence(){
    let start_id=this.getStart().id;
    let list=[];
    this.addAllLine(list,start_id,[start_id]);
    return list;
  }

  /**
   * 查询选择的路线
   * @param where 节点列表,如['c5a07253-d49e-43e1-b5e7-5fec20512b81','1e19ec92-30cd-403a-b91a-20fef0fc2267']
   * @returns {*[]}
   */
  chooseAllSequence(where=[]){
    let flow_paths=this.getAllSequence();
    let flow_path=[];
    flow_paths.forEach((value,item)=>{
      let st=new Set(value);
      where.map(ret=>{ st.add(ret) });
      let node_path=Array.from(st);
      // console.log(node_path.length,value.length,node_path)
      if(node_path.length===value.length){
        flow_path.push(value)
      }
    })
    return flow_path;
  }

  /**
   * 获取开始节点
   * @returns {*|null}
   */
  getStart(){
    return this.find('type','start');
  }

  /**
   * 获取结束节点
   * @returns {*|null}
   */
  getEnd(){
    return this.find('type','end');
  }

  /**
   * 排序节点序列ID
   * @param list
   * @param node_id
   * @param _node_ids
   */
  addLine(list, node_id, _node_ids){
    let edges_list=this.findEdgesList('sourceNodeId',node_id);
    if(edges_list.length===1){
      let edges=edges_list[0];
      if(edges&&edges.targetNodeId){
        let node_ids=FlowFramework.reJson(_node_ids)
        node_ids.push(edges.targetNodeId);
        if(this.getEnd().id===edges.targetNodeId){
          list.push(node_ids);
        }else{
          this.addLine(list,edges.targetNodeId,FlowFramework.reJson(node_ids));
        }
      }
    }else if (edges_list.length>1){
      edges_list.forEach((value,item)=>{
        if(value&&value.targetNodeId){
          let node_ids=FlowFramework.reJson(_node_ids)
          node_ids.push(value.targetNodeId);
          this.addLine(list,value.targetNodeId,FlowFramework.reJson(node_ids));
        }
      })
    }
  }

  /**
   * 排序节点序列ID（包含线）
   * @param list
   * @param node_id
   * @param _node_ids
   */
  addAllLine(list, node_id, _node_ids){
    let edges_list=this.findEdgesList('sourceNodeId',node_id);
    if(edges_list.length===1){
      let edges=edges_list[0];
      if(edges&&edges.targetNodeId){
        let node_ids=FlowFramework.reJson(_node_ids)
        node_ids.push(edges.id);
        node_ids.push(edges.targetNodeId);
        if(this.getEnd().id===edges.targetNodeId){
          list.push(node_ids);
        }else{
          this.addAllLine(list,edges.targetNodeId,FlowFramework.reJson(node_ids));
        }
      }
    }else if (edges_list.length>1){
      edges_list.forEach((value,item)=>{
        if(value&&value.targetNodeId){
          let node_ids=FlowFramework.reJson(_node_ids)
          node_ids.push(value.id);
          node_ids.push(value.targetNodeId);
          this.addAllLine(list,value.targetNodeId,FlowFramework.reJson(node_ids));
        }
      })
    }
  }


  /**
   * 所有节点查询
   * @param name 查询名称
   * @param value 查询值
   * @returns {null|*}
   */
  find(name, value) {
    let arr_cols = this.all_graph_list.map(ret=>ret[name]);
    let index = arr_cols.indexOf(value);
    if (index !== -1) {
      return this.all_graph_list[index];
    } else {
      return null;
    }
  }

  /**
   * 获取节点标题
   * @param name 查询名称
   * @param value 查询值
   * @returns {*|string}
   */
  getNodeText(name, value){
    let node=this.find(name,value);
    return (node['text']||{})['value']||"";
  }

  /**
   * 连接线节点查询
   * @param name 查询名称
   * @param value 查询值
   * @returns {null|*}
   */
  findEdges(name, value){
    let arr_cols=this.graph_data.edges.map(ret=>ret[name]);
    let index= arr_cols.indexOf(value);
    if(index!==-1){
      return this.graph_data.edges[index];
    }else{
      return null;
    }
  }

  /**
   * 连接线节点查询列表
   * @param name 查询名称
   * @param value 查询值
   * @returns {*[]}
   */
  findEdgesList(name, value) {
    let list=[];
    this.graph_data.edges.forEach(edge=>{
      if(edge[name]===value){
        list.push(edge);
      }
    })
    return list;
  }

  /**
   * 查询节点的
   * @param name 查询名称
   * @param value 查询值
   * @returns {null|*}
   */
  findNode(name, value){
    let arr_cols=this.graph_data.nodes.map(ret=>ret[name]);
    let index= arr_cols.indexOf(value);
    if(index!==-1){
      return this.graph_data.nodes[index];
    }else{
      return null;
    }
  }

  /**
   * 连接线节点查询列表
   * @param name 查询名称
   * @param value 查询值
   * @returns {*[]}
   */
  findNodeList(name, value) {
    let list=[];
    this.graph_data.nodes.forEach(edge=>{
      if(edge[name]===value){
        list.push(edge);
      }
    })
    return list;
  }

  /**
   * 获取节点附加参数
   * @param name
   * @param value
   * @returns {null|*}
   */
  getProperties(name, value){
    let data=this.find(name,value);
    if(data){
      return data.properties;
    }else{
      return null;
    }
  }

  /**
   * 获取业务类型
   * @param key 键
   * @param value 值
   * @returns {*[]}
   */
  static getBusiness(key, value) {
    let list=[];
    FlowFramework.business_list.forEach(val=>{
      if(val[key]===value){
        list.push(val);
      }
    })
    return list;
  }

  static reJson(obj){
    return JSON.parse(JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/lib/FlowFramework.js